// OTP Request Error Codes with English and Arabic descriptions for end users

export const otpRequestCodes = {

  10200: {

    en: "Pin sent successfully",

    ar: "تم إرسال رمز التحقق إلى هاتفك بنجاح. يرجى إدخال الرمز لإكمال العملية."

  },

  10102: {

    en: "Access denied",

    ar: "لم نتمكن من التحقق من رقم الهاتف. يرجى التأكد من الرقم المدخل والمحاولة مرة أخرى."

  },

  10201: {

    en: "Error in generating pin",

    ar: "حدث خطأ أثناء إرسال رمز التحقق. يرجى المحاولة مرة أخرى بعد قليل."

  },

  10204: {

    en: "User already subscribed",

    ar: "أنت مشترك بالفعل في هذه الخدمة. يمكنك تسجيل الدخول مباشرة والمتابعة لاستخدام التطبيق."

  },

  10210: {

    en: "User not eligible",

    ar: "لا يمكنك إكمال العملية باستخدام هذا الرقم حاليًا. يرجى استخدام رقم آخر أو التواصل مع الدعم."

  },

  10212: {

    en: "Pin generation limit reached",

    ar: "لقد تجاوزت عدد المحاولات المسموح بها لإرسال رمز التحقق. يرجى الانتظار قليلًا ثم المحاولة مرة أخرى."

  },

  10213: {

    en: "Missing information",

    ar: "حدث خطأ أثناء إرسال الطلب بسبب نقص في البيانات. يرجى المحاولة مرة أخرى."

  }

};
 
export const getOtpErrorMessage = (code, locale = 'ar') => {
  const errorCode = otpRequestCodes[code];
  if (!errorCode) {

    return locale === 'en'

      ? "An unexpected error occurred"

      : "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقًا.";

  }

  return errorCode[locale] || errorCode['ar'];

};
 
 
const verifyOtpCodes = {

  10300: {

    en: "Verified successfully",

    ar: "تم التحقق من الرمز بنجاح."

  },

  10301: {

    en: "Invalid pin",

    ar: "رمز التحقق الذي أدخلته غير صحيح. يرجى التأكد من الرمز والمحاولة مرة أخرى."

  },

  10302: {

    en: "Pin expired",

    ar: "انتهت صلاحية رمز التحقق. يرجى طلب رمز جديد والمحاولة مرة أخرى."

  },

  10303: {

    en: "Pin verification limit reached",

    ar: "لقد تجاوزت عدد المحاولات المسموح بها للتحقق من الرمز. يرجى الانتظار قليلًا ثم طلب رمز جديد."

  },

  10309: {

    en: "User already subscribed",

    ar: "أنت مشترك بالفعل في هذه الخدمة. يمكنك تسجيل الدخول مباشرة والمتابعة لاستخدام التطبيق."

  },

  10312: {

    en: "Pin expired",

    ar: "انتهت صلاحية رمز التحقق. يرجى طلب رمز جديد والمحاولة مرة أخرى."

  },

  10313: {

    en: "Insufficient balance",

    ar: "رصيدك غير كافٍ لإتمام الاشتراك. يرجى شحن الرصيد ثم المحاولة مرة أخرى."

  },

  10323: {

    en: "Insufficient loyalty balance",

    ar: "رصيدك غير كافٍ لإتمام الاشتراك. يرجى شحن الرصيد ثم المحاولة مرة أخرى."

  }

};
 
export const getVerifyOtpErrorMessage = (code, locale = 'ar') => {

  const errorCode = verifyOtpCodes[code];

  if (!errorCode) {

    return locale === 'en'

      ? "An unexpected error occurred"

      : "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقًا.";

  }

  return errorCode[locale] || errorCode['ar'];

};

 